import Api from "../services/AxiosService";
import { unwrap } from "./envelope";

// svc-04 `GET /v1/admin/analytics/summary`. Mirror of the backend
// AnalyticsSummary contract (`@penn/shared-types`); kept local per the
// existing `api/*.ts` convention. Backs the admin Analytics dashboard.

export interface TopCountItem {
  name: string;
  count: number;
}

export interface TopPathItem {
  path: string;
  count: number;
}

export interface RecentEvent {
  ts: string | null;
  eventName: string | null;
  userEmail: string | null;
  isInternal: boolean | null;
  path: string | null;
  sessionId: string | null;
}

export interface QuoteTimeBucket {
  count: number;
  avgHours: number | null;
  p50Hours: number | null;
}

export interface QuoteTime {
  overall: QuoteTimeBucket;
  standard: QuoteTimeBucket;
  custom: QuoteTimeBucket;
}

export interface AnalyticsSummary {
  days: number;
  totalEvents: number;
  uniqueSessions: number;
  knownUsers: number;
  topEvents: TopCountItem[];
  topPaths: TopPathItem[];
  recentEvents: RecentEvent[];
  /** Total recent events in the window (for offset pagination of recentEvents). */
  recentTotal: number;
  recommendations: string[];
  quoteTime: QuoteTime;
  responsibilities: string[];
  responsibilityFilter: string;
}

export interface AnalyticsSummaryParams {
  days?: number;
  responsibility?: string;
  /** Recent-activity page size (offset pagination). */
  recentLimit?: number;
  /** Recent-activity offset (offset pagination). */
  recentOffset?: number;
}

const BASE = "/v1/admin/analytics/summary";

export async function getAnalyticsSummary(
  params: AnalyticsSummaryParams = {},
): Promise<AnalyticsSummary> {
  const res = await Api.get(BASE, { params });
  return unwrap<AnalyticsSummary>(res.data);
}
